module.exports = __webpack_public_path__ + "static/p-11 - Copy-8de6c5edbda2d335ba68aea6114cae62.jpg";